<template>
  <div class="page-wrapper" :class="pageClass" v-if="user">
    <notifications group="default" />
    <div id="sidebar">
      <router-link :to="{ name: 'dashboard' }">
        <div class="logo">
          <img alt="Logo" :src="'/assets/' + platformName + '/logo.png'" />
        </div>
      </router-link>
      <SideMenu />
      <div class="octava" v-if="poweredByOvalio">
        <img
          alt="Logo"
          src="/assets/ovalio-icon.png"
          width="50px"
          class="mb-1"
          style="opacity: 0.75"
        />
        <h3>
          OCTAVA
          <span style="font-size: 1rem">V2.1</span>
        </h3>
        <div class="text-muted">
          <small>Powered by</small>
          <div>Ovalio Solutions LTD</div>
        </div>
      </div>
    </div>
    <div class="wrap">
      <header class="layout-header">
        <a href="javascript:void(0);" class="nav-btn" @click="toggleSidebar">
          <i class="la la-bars la-lg"></i>
        </a>
        <div class="user-info">
          <span class="mr-3 name">{{ user.name }}</span>
          <span class="avatar-container">
            <b-avatar
              button
              @click="toggleProfileMenu()"
              variant="info"
            ></b-avatar>
            <ul
              role="menu"
              class="profile-dropdown-menu dropdown-menu dropdown-menu-right"
              :class="{ show: showProfileMenu }"
            >
              <li role="presentation">
                <a class="dropdown-item" @click="goToProfileSettings()" href="javascript:void(0);">
                  <i class="la la-cog mr-2"></i>
                  Profile Settings
                </a>
              </li>
              <li role="presentation">
                <hr role="separator" aria-orientation="horizontal" class="dropdown-divider" />
              </li>
              <li role="presentation">
                <a class="dropdown-item" @click="logout()" href="javascript:void(0);">
                  <i class="la la-sign-out mr-2"></i>
                  Sign out
                </a>
              </li>
            </ul>
          </span>
        </div>
      </header>
      <div id="content">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
import NProgress from 'nprogress';
import SideMenu from './SideMenu.vue';
import { listStateKey, loadListState, saveListState } from '../lib/listState';

const layoutStateKey = () => listStateKey('layout:sidebar');

export default {
  name: 'Layout',
  components: { SideMenu },
  computed: {
    pageClass() {
      return (
        (this.toggledSidebar ? 'sidebar-toggled' : 'sidebar-default') +
        ' theme-' +
        this.platformName
      );
    },
    user() {
      return this.$store.state.user;
    },
    toggledSidebar() {
      return this.$store.state.toggledSidebar;
    },
  },
  data() {
    return {
      platformName: this.$platformName,
      poweredByOvalio: this.$poweredByOvalio,
      showProfileMenu: false,
    };
  },
  methods: {
    logout() {
      this.$store.dispatch('setUser', null);
      this.$router.push({ name: 'login' });
    },
    toggleSidebar() {
      this.$store.commit('toggle', 'toggledSidebar');
      saveListState(layoutStateKey(), { toggledSidebar: this.$store.state.toggledSidebar });
    },
    restoreSidebarStateFromSession() {
      const loaded = loadListState(layoutStateKey());
      const saved = loaded && loaded.ok && loaded.payload ? loaded.payload.toggledSidebar : undefined;
      if (typeof saved !== 'boolean') return false;

      this.$store.state.toggledSidebar = saved;
    },
    toggleProfileMenu() {
      this.showProfileMenu = !this.showProfileMenu;
    },
    goToProfileSettings() {
      this.showProfileMenu = false;
      this.$router.push({ name: 'profile' });
    },
  },
  mounted() {
    NProgress.done();
  },
  created() {
    NProgress.start();
    this.restoreSidebarStateFromSession();
  },
};
</script>
